<template>
  <div class="grid-container">
    <div v-if="!loading" class="grid-x">
      <h3 class="cell subtitle">Top Torneos Populares del mes:</h3>
      <div 
        class="cell small-6 medium-4 large-3"
        v-for="torneo in torneos"
        :key="torneo.id">
        <v-card-simple-torneo
          :image="torneo.image"
          :name="torneo.name"
          :simpleText="torneo.contry"
          :tagText="torneo.competition.category.name"
          :link="{name: 'home-detalle-torneo', params: {'idTorneo': torneo.id}}"
          actionText="Ver Torneo"
        />
      </div>
    </div>
    <div v-else>
      <app-loading />
    </div>
  </div>
</template>

<script>
  // api
  import { torneosPopulares } from '@/api/Torneo'
  //
  import VCardSimpleTorneo from '@/components/base/VCardSimpleTorneo.vue'
  //
  

  export default {
    name: 'TheTorneosPopularesMes',
    components: {
      VCardSimpleTorneo
    },
    data() {
      return {
        torneos: [],
        loading: false
      }
    },
    methods: {
      cargarTorneo: function () {
        this.loading = true
        torneosPopulares(4).then(
          (response) => {
            this.loading = false
            this.torneos = response.data
          }
        ).catch (
          () => this.loading = false
        )
      }
    },
    beforeMount() {
      this.cargarTorneo()
    },
  }
</script>

<style lang="scss" scoped>

</style>